import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { inputClasses } from "./input";

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return <textarea data-slot="textarea" className={cn(inputClasses, "min-h-24 resize-y leading-relaxed", className)} {...props} />;
}
